import type { FC, PropsWithChildren } from 'react';

import Navbar from '@/components/navbar';
import Sidebar from '@/components/sidebar';
import { Footer } from 'flowbite-react';
// import { MdFacebook } from 'react-icons/md';
// import { FaDribbble, FaGithub, FaInstagram, FaTwitter } from 'react-icons/fa';
import { SidebarProvider, useSidebarContext } from '@/context/SidebarContext';
import classNames from 'classnames';

interface NavbarSidebarLayoutProps {
  isFooter?: boolean;
}

const NavbarSidebarLayout: FC<PropsWithChildren<NavbarSidebarLayoutProps>> =
  function ({ children, isFooter = true }) {
    return (
      <SidebarProvider>
        <Navbar />
        <div className="flex h-full items-start pt-16">
          <Sidebar />
          <MainContent isFooter={isFooter}>{children}</MainContent>
        </div>
      </SidebarProvider>
    );
  };

const MainContent: FC<PropsWithChildren<NavbarSidebarLayoutProps>> = function ({
  children,
  isFooter,
}) {
  const { isOpenOnSmallScreens: isSidebarOpen } = useSidebarContext();

  return (
    <main
      className={classNames(
        'relative w-full h-full bg-gray-50 dark:bg-gray-900 transition-margin duration-150 overflow-x-hidden',
        isSidebarOpen ? 'lg:ml-16' : 'lg:ml-64'
      )}
    >
      {children}
      {isFooter && (
        <div className="mx-4 mt-4">
          <MainContentFooter />
        </div>
      )}
    </main>
  );
};

const MainContentFooter: FC = function () {
  return (
    <>
      <Footer container>
        <div className="flex w-full flex-col gap-y-6 lg:flex-row lg:justify-between lg:gap-y-0">
          <Footer.LinkGroup>
            <Footer.Link href="#" className="mr-3 mb-3 lg:mb-0">
              Условия и положения
            </Footer.Link>
            <Footer.Link href="#" className="mr-3 mb-3 lg:mb-0">
              Политика конфиденциальности
            </Footer.Link>
            {/* <Footer.Link href="#" className="mr-3">
              Licensing
            </Footer.Link> */}
            <Footer.Link href="#" className="mr-3">
              Политика использования файлов cookie
            </Footer.Link>
            <Footer.Link href="#">Контакты</Footer.Link>
          </Footer.LinkGroup>
          {/* <Footer.LinkGroup>
            <div className="flex gap-x-1">
              <Footer.Link
                href="#"
                className="hover:[&>*]:text-black dark:hover:[&>*]:text-gray-300"
              >
                <MdFacebook className="text-lg" />
              </Footer.Link>
              <Footer.Link
                href="#"
                className="hover:[&>*]:text-black dark:hover:[&>*]:text-gray-300"
              >
                <FaInstagram className="text-lg" />
              </Footer.Link>
              <Footer.Link
                href="#"
                className="hover:[&>*]:text-black dark:hover:[&>*]:text-gray-300"
              >
                <FaTwitter className="text-lg" />
              </Footer.Link>
              <Footer.Link
                href="#"
                className="hover:[&>*]:text-black dark:hover:[&>*]:text-gray-300"
              >
                <FaGithub className="text-lg" />
              </Footer.Link>
              <Footer.Link
                href="#"
                className="hover:[&>*]:text-black dark:hover:[&>*]:text-gray-300"
              >
                <FaDribbble className="text-lg" />
              </Footer.Link>
            </div>
          </Footer.LinkGroup> */}
        </div>
      </Footer>
      <p className="my-8 text-center text-sm text-gray-500 dark:text-gray-300">
        &copy; 2022-{new Date().getFullYear()} mpSERPent
      </p>
    </>
  );
};

export default NavbarSidebarLayout;
